import styled from 'styled-components'
import SupportTextNew from 'presentation/shared/components/SupportTextNew'

export const Label = styled(SupportTextNew)`
  margin-bottom: 12px;
`
